import React, { FC } from 'react';

interface Props {
  color: string;
  direction: 'left' | 'right' | 'up' | 'down';
  onClick?: () => void;
  clickable?: boolean;
  className?: string;
}

const Arrow: FC<Props> = ({ color, direction, clickable, onClick, className }) => {
  return (
    <svg
      className={className}
      width="9"
      height="19"
      fill="none"
      onClick={clickable && onClick ? () => onClick() : undefined}
      xmlns="http://www.w3.org/2000/svg"
      style={
        direction === 'right'
          ? { transform: 'rotate(180deg)' }
          : direction === 'up'
          ? { transform: 'rotate(90deg)' }
          : direction === 'down'
          ? { transform: 'rotate(270deg)' }
          : {}
      }
    >
      <path
        d="M8.306 18.293h-3.84L0 9.15 4.465 0h3.841L3.841 9.15l4.465 9.144Z"
        fill={color}
        style={clickable ? { cursor: 'pointer' } : {}}
      />
    </svg>
    // <svg width="7" height="15" fill="none" xmlns="http://www.w3.org/2000/svg">
    //   <path
    //     d="M0 0h3.149l3.662 7.498L3.149 15h-3.15l3.662-7.502L0 0Z"

    //     }
    //   />
    // </svg>
  );
};
export default Arrow;
